import { connect } from 'react-redux'
import Train from '../components/train_positions/Train'

const mapStateToProps = state => {
  const {
    trainIconSettings,
    nankai_update_date,
    nankai_update_time,
    koya_update_date,
    koya_update_time,
   } = state.trainPositionReducer

  return {
    trainIconSettings,
    nankai_update_date,
    nankai_update_time,
    koya_update_date,
    koya_update_time,
  }
}

export default connect(
  mapStateToProps
)(Train)

